<script lang="ts" setup>
import type { CSSProperties  } from 'vue'

import { reactive, computed  } from 'vue'
import { isString            } from '@sumdoo/shared'
import { sdImageProps        } from './image'
import { Picture, Loading    } from '@element-plus/icons-vue'
import { ElImage, ElIcon     } from 'element-plus'

defineOptions({ name: 'SdImage' })

const props = defineProps(sdImageProps)
const emit  = defineEmits(['load', 'error', 'switch', 'close'])

const state = reactive({
    previewSrcList: [] as string[],
    loadSuccess   : false,
})

const imageStyle$ = computed(() => {
    const { width, height, minHeight, borderRadius, circle } = props

    const styles: CSSProperties = {}
    if (width    ) styles.width     = isString(width    ) ? width     : width     + 'px'
    if (height   ) styles.height    = isString(height   ) ? height    : height    + 'px'
    if (minHeight) styles.minHeight = isString(minHeight) ? minHeight : minHeight + 'px'
    if (borderRadius) {
        styles.borderRadius = isString(borderRadius) ? borderRadius : borderRadius + 'px'
    } 
    if (circle) {
        styles.borderRadius = '50%'
    }

    return styles
})

const previewSrcList$ = computed(() => {
    if (!props.preview             ) return []
    if (props.previewSrcList.length) return props.previewSrcList 
    return state.loadSuccess ? [props.src] : []
})

const onLoad = (e: Event) => {
    emit('load', e)
    state.loadSuccess = true
}

const onError = (e: Event) => {
    emit('error', e)
    state.loadSuccess = false
}
</script>

<template>
    <ElImage
        class="sd-image"
        :alt="$attrs.alt"
        :fit="fit"
        :hide-on-click-modal="hideOnClickModal"
        :initial-index="initialIndex"
        :lazy="lazy"
        :preview-src-list="previewSrcList$"
        :referrer-policy="$attrs.referrerPolicy"
        :src="src"
        :scroll-container="scrollContainer"
        :z-index="zIndex"
        :preview-teleported="previewTeleported"
        :style="imageStyle$"
        @load="onLoad"
        @error="onError"
        @close="$emit('close')"
        @switch="$emit('switch', $event)"
    >
        <template #placeholder >
            <slot name="placeholder">
                <div class="el-image__placeholder" :style="imageStyle$">
                    <ElIcon class="is-loading" :size="30" color="#999">
                        <Loading />
                    </ElIcon>
                </div>
            </slot>
        </template>

        <template #error>
            <slot name="error">
                <div class="el-image__error" :style="imageStyle$">
                    <ElIcon :size="30">
                        <Picture />
                    </ElIcon>
                </div>
            </slot>
        </template>
    </ElImage>
</template>
